import { useState, useEffect } from 'react';
import { maskCpfCnpj } from "../../utils/documento";
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findRegistro from '../../service/findRegistro';
import { SortOrder } from 'primereact/api';
import { Button } from 'primereact/button';
import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Nullable } from 'primereact/ts-helpers';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import "./styles.css";
import { Card } from 'primereact/card';
import { Tooltip } from 'primereact/tooltip';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import getRegistroDownload from '../../service/getRegistroDownload';
import { Dropdown } from 'primereact/dropdown';
import findClient from '../../service/findClient';

// Cor e ícone de cada status, usados nos cards de resumo.
const STATUS_CARD_CONFIG: Record<string, { color: string; icon: string }> = {
  INCLUIDO: { color: 'var(--blue-500, #3b82f6)', icon: 'pi pi-file-plus' },
  REGISTRADO: { color: 'var(--green-500, #22c55e)', icon: 'pi pi-check-circle' },
  PUBLICADO: { color: 'var(--cyan-500, #06b6d4)', icon: 'pi pi-send' },
  EXCLUIDO: { color: 'var(--orange-500, #f97316)', icon: 'pi pi-trash' },
  CANCELADO: { color: 'var(--yellow-500, #eab308)', icon: 'pi pi-ban' },
  ERRO: { color: 'var(--red-500, #ef4444)', icon: 'pi pi-exclamation-triangle' },
  ERRO_EXCLUSAO: { color: 'var(--pink-500, #ec4899)', icon: 'pi pi-exclamation-circle' },
};
const TOTAL_CARD_CONFIG = { color: 'var(--teal-500, #14b8a6)', icon: 'pi pi-chart-bar' };
const getCardConfig = (status: string) => STATUS_CARD_CONFIG[status] ?? TOTAL_CARD_CONFIG;

// Classe de cor e ícone do badge a partir do rótulo exibido (tabela),
// mantendo a mesma identidade visual dos cards de resumo.
const STATUS_LABEL_CONFIG: Record<string, { badgeClass: string; icon: string }> = {
  'Incluído': { badgeClass: 'status-badge-incluido', icon: 'pi pi-file-plus' },
  'Registrado': { badgeClass: 'status-badge-registrado', icon: 'pi pi-check-circle' },
  'Publicado': { badgeClass: 'status-badge-publicado', icon: 'pi pi-send' },
  'Excluído': { badgeClass: 'status-badge-excluido', icon: 'pi pi-trash' },
  'Cancelado': { badgeClass: 'status-badge-cancelado', icon: 'pi pi-ban' },
  'Erro': { badgeClass: 'status-badge-erro', icon: 'pi pi-exclamation-triangle' },
  'Erro inclusão': { badgeClass: 'status-badge-erro', icon: 'pi pi-exclamation-triangle' },
  'Erro exclusão': { badgeClass: 'status-badge-erro-exclusao', icon: 'pi pi-exclamation-circle' },
  'Total': { badgeClass: 'status-badge-total', icon: 'pi pi-chart-bar' },
};
const getLabelConfig = (label: string) =>
  STATUS_LABEL_CONFIG[label] ?? { badgeClass: 'status-badge-total', icon: 'pi pi-chart-bar' };

export default function RegistroList({ onEdit, date }: { onEdit: (registro: any) => void, date: Date }) {
  const { t } = useTranslation();
  const [registros, setRegistros] = useState(undefined);
  const [counts, setCounts] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [nome, setNome] = useState<Nullable<string | null>>(null);
  const [documento, setDocumento] = useState<Nullable<string | null>>(null);
  const [data, setData] = useState<Nullable<Date>>(new Date(new Date().setDate(new Date().getDate() - 30)));
  const [dataFinal, setDataFinal] = useState<Nullable<Date>>(new Date());
  const [status, setStatus] = useState<Nullable<String | null>>(null);
  const [usuario, setUsuario] = useState<Nullable<string | null>>(null);
  const [descricaoErro, setDescricaoErro] = useState(undefined);
  const { state } = useGlobalState();
  const [clients, setClients] = useState<any>([]);
  const [selectedClient, setSelectedClient] = useState<any>(null);

  const padTo2Digits = (num: number) => {
    return num.toString().padStart(2, '0');
  }

  const formatDate = (date: Nullable<Date>) => {
    if (date) {
      return [
        padTo2Digits(date.getDate()),
        padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('-');
    }
    else {
      return null;
    }

  }

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    data: formatDate(data),
    dataFinal: formatDate(dataFinal),
    nome: nome,
    documento: documento,
    status: status,
    loginUsuario: usuario,
    cliente: selectedClient ? selectedClient.code : null,
    sortField: 't.dataInclusao',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      nome: nome ? nome : null,
      documento: documento ? documento : null,
      status: status,
      loginUsuario: usuario ? usuario : null,
      cliente: selectedClient ? selectedClient.code : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event: any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      nome: nome ? nome : null,
      documento: documento ? documento : null,
      status: status,
      loginUsuario: usuario ? usuario : null,
      cliente: selectedClient ? selectedClient.code : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const changeData = (data: Nullable<Date>) => {
    if (data) {
      setData(data);
      setlazyState({
        first: lazyState.first,
        rows: lazyState.rows,
        page: (lazyState.first / lazyState.rows) + 1,
        data: formatDate(data),
        dataFinal: formatDate(dataFinal),
        nome: nome,
        documento: documento,
        status: status,
        loginUsuario: usuario,
        cliente: selectedClient ? selectedClient.code : null,
        sortField: 't.dataInclusao',
        sortOrder: SortOrder.DESC
      });
    }
  }

  const changeDataFinal = (dataFi: Nullable<Date>) => {
    if (dataFi) {
      setDataFinal(dataFi);
      setlazyState({
        first: lazyState.first,
        rows: lazyState.rows,
        page: (lazyState.first / lazyState.rows) + 1,
        data: formatDate(data),
        dataFinal: formatDate(dataFi),
        nome: nome,
        documento: documento,
        status: status,
        loginUsuario: usuario,
        cliente: selectedClient ? selectedClient.code : null,
        sortField: 't.dataInclusao',
        sortOrder: SortOrder.DESC
      });
    }
  }


  const changeNome = (nome: Nullable<string>) => {
    nome = nome ? nome : null
    setNome(nome);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: (lazyState.first / lazyState.rows) + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      nome: nome,
      documento: documento ? documento : null,
      status: status,
      loginUsuario: usuario ? usuario : null,
      cliente: selectedClient ? selectedClient.code : null,
      sortField: 't.dataInclusao',
      sortOrder: SortOrder.DESC
    });

  }

  const changeStatus = (status: Nullable<any>) => {
    status = status ? status : null
    if (status instanceof Object) {
      status = null
    }

    setStatus(status);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: (lazyState.first / lazyState.rows) + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      nome: nome ? nome : null,
      documento: documento ? documento : null,
      status: status,
      loginUsuario: usuario ? usuario : null,
      cliente: selectedClient ? selectedClient.code : null,
      sortField: 't.dataInclusao',
      sortOrder: SortOrder.DESC
    });

  }

  const changeUsuario = (usuario: Nullable<string>) => {
    usuario = usuario ? usuario : null
    setUsuario(usuario);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: (lazyState.first / lazyState.rows) + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      nome: nome ? nome : null,
      documento: documento ? documento : null,
      status: status,
      loginUsuario: usuario,
      cliente: selectedClient ? selectedClient.code : null,
      sortField: 't.dataInclusao',
      sortOrder: SortOrder.DESC
    });
  }

  const changeCliente = (value: any) => {

    setSelectedClient(value);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: (lazyState.first / lazyState.rows) + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      nome: nome ? nome : null,
      documento: documento ? documento : null,
      status: status,
      loginUsuario: usuario ? usuario : null,
      cliente: value ? value.code : null,
      sortField: 't.dataInclusao',
      sortOrder: SortOrder.DESC
    });

  }

  const changeDocumento = (doc: Nullable<string>) => {
    doc = doc ? doc : null
    setDocumento(doc);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: (lazyState.first / lazyState.rows) + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      nome: nome ? nome : null,
      documento: doc,
      status: status,
      loginUsuario: usuario ? usuario : null,
      cliente: selectedClient ? selectedClient.code : null,
      sortField: 't.dataInclusao',
      sortOrder: SortOrder.DESC
    });

  }

  const cols = [
    { field: 'cliente', header: 'Cliente' },
    { field: 'documento', header: 'Documento' },
    { field: 'nome', header: 'Nome' },
    { field: 'contrato', header: 'Contrato' },
    { field: 'valor', header: 'Valor' },
    { field: 'ocorrencia', header: 'Dt. Ocorrência' },
    { field: 'dataInclusao', header: 'Dt. Inclusão' },
    { field: 'email', header: 'E-mail' },
    { field: 'sms', header: 'SMS' },
    { field: 'status', header: 'Status' }
  ];
  const exportColumns = cols.map((col) => ({ header: col.header, dataKey: col.field }));
  const exportPdf = () => {
    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then(({ default: autoTable }) => {
        const lazy = {
          first: 0,
          rows: totalRecords,
          page: 1,
          data: formatDate(data),
          dataFinal: formatDate(dataFinal),
          nome: nome ? nome : null,
          documento: documento ? documento : null,
          status: status,
          loginUsuario: usuario ? usuario : null,
          cliente: selectedClient ? selectedClient.code : null,
          sortField: 't.dataInclusao',
          sortOrder: SortOrder.DESC
        }
        findRegistro(lazy).then(data => {
          const doc: any = new jsPDF.default('portrait');
          autoTable(doc, { columns: exportColumns, body: data.registros });
          doc.save('registros.pdf');
        });

      });
    });
  };

  const exportExcel = () => {
    import('xlsx').then((xlsx) => {
      const lazy = {
        first: 0,
        rows: totalRecords,
        page: 1,
        data: formatDate(data),
        dataFinal: formatDate(dataFinal),
        nome: nome ? nome : null,
        documento: documento ? documento : null,
        status: status,
        loginUsuario: usuario ? usuario : null,
        cliente: selectedClient ? selectedClient.code : null,
        sortField: 't.dataInclusao',
        sortOrder: SortOrder.DESC
      }
      findRegistro(lazy).then(data => {
        const worksheet = xlsx.utils.json_to_sheet(data.registros);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
        saveAsExcelFile(excelBuffer, 'registros');
      });


    });
  };

  const handleDocumento = (event: any) => {
    event.target.value = maskCpfCnpj(event.target.value)
  }

  const clearFields = () => {
    setStatus(null);
    setNome('');
    setUsuario('');
    setDocumento('');
    setSelectedClient(null);
    setData(null)
    setDataFinal(null)

    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: (lazyState.first / lazyState.rows) + 1,
      data: formatDate(null),
      dataFinal: formatDate(null),
      nome: null,
      documento: null,
      status: status,
      loginUsuario: null,
      cliente: selectedClient ? selectedClient.code : null,
      sortField: 't.dataInclusao',
      sortOrder: SortOrder.DESC
    });
  };

  const saveAsExcelFile = (excelBuffer: any, fileName: string) => {
    import('file-saver').then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([excelBuffer], {
          type: EXCEL_TYPE
        });

        module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    });
  };

  const downloadRegistro = (registro: any) => {
    getRegistroDownload(registro.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `registro.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };

  const downloadTemplate = (registro: any) => {
    return (

      <Button
        icon="pi pi-file-pdf"
        onClick={() => {
          downloadRegistro(registro);
        }}
        style={{
          background: "transparent",
          color: "gray",
          border: "none",
        }}
      />


    );
  };

  const header = (
    <div className="flex-consulta align-items-center justify-content-end gap-2">
      <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
      <Button type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={exportPdf} data-pr-tooltip="PDF" />
    </div>
  );

  const startContent = (
    <div className="filtros">
      <div className="filtros-grid">
        <div className="filtros-item">
          <label htmlFor="data" className="font-bold">{t('dataInicial')}</label>
          <Calendar id='data' value={data} onChange={(e) => changeData(e.value)} showIcon dateFormat="dd/mm/yy" locale='pt' />
        </div>
        <div className="filtros-item">
          <label htmlFor="dataFinal" className="font-bold">{t('dataFinal')}</label>
          <Calendar id='dataFinal' value={dataFinal} onChange={(e) => changeDataFinal(e.value)} showIcon dateFormat="dd/mm/yy" locale='pt' />
        </div>
        <div className="filtros-item">
          <label htmlFor="documento" className="font-bold">{t('documento')}</label>
          <InputText id="documento" value={documento} onChange={(e) => setDocumento(e.target.value)} maxLength={18} max={18} onKeyUp={handleDocumento} onBlur={(e) => changeDocumento(e.target.value)} />
        </div>
        <div className="filtros-item">
          <label htmlFor="nome" className="font-bold">{t('nome')}</label>
          <InputText id="nome" value={nome} onChange={(e) => setNome(e.target.value)} onBlur={(e) => changeNome(e.target.value)} />
        </div>
        <div className="filtros-item">
          <label htmlFor="usuario" className="font-bold">{t('usuario')}</label>
          <InputText id="usuario" value={usuario} onChange={(e) => setUsuario(e.target.value)} onBlur={(e) => changeUsuario(e.target.value)} />
        </div>
        {!state.user.cliente && (
          <div className="filtros-item">
            <label htmlFor="codigoCliente" className="font-bold">{t('credor')}</label>
            <Dropdown id="codigoCliente" value={selectedClient} onChange={(e) => { changeCliente(e.value) }} options={clients} optionLabel="name" placeholder="Selecione Cliente" showClear filter />
          </div>
        )}
      </div>
      <div className="filtros-acoes">
        <Button label='Limpar' icon="pi pi-times" onClick={clearFields} className="button_remove_backgroung" outlined style={{ color: '#183462' }} />
      </div>
    </div>
  );

  const loadLazyData = () => {
    findRegistro(lazyState).then(data => { setTotalRecords(data.total); setCounts(data.status); setRegistros(data.registros) }).catch(() => { setTotalRecords(0); setRegistros(undefined); setCounts([]) });
  }

  const statusTemplate = (registro: any) => {

    const cfg = getLabelConfig(registro.status)
    return <>
      {registro.descricaoCancelamento && (
        <Tooltip target={'.custom-tooltip-btn_' + registro.id}>
          {registro.descricaoCancelamento.split('<br/>').map((texto: string) => <><span>{texto}</span><br></br></>)}

        </Tooltip>
      )}
      <span className={'status-pill ' + cfg.badgeClass + (registro.descricaoCancelamento ? ' custom-tooltip-btn_' + registro.id + ' custom-cursor' : '')}>
        <i className={cfg.icon}></i>
        {registro.status}
      </span></>
  }
  const resetForm = () => {
    setDescricaoErro(undefined);
  }
  const footerContent = (
    <React.Fragment>
      <Button label="Fechar" icon="pi pi-times" style={{ color: '#183462' }} onClick={() => resetForm()} className="p-button-text" />
    </React.Fragment>
  );

  const actionTemplate = (event: any) => {
    return (
      <div className="flex flex-wrap gap-2" style={{ display: 'flex', justifyContent: 'end' }}>
        {event.status.includes('Erro') && (<Button icon="pi pi-search" onClick={() => { setDescricaoErro(event.descricaoErro) }} style={{ background: 'transparent', color: 'gray', border: 'none' }} />)}
        {event.status !== 'Excluído' && event.status !== 'Cancelado' && !event.status.includes('Erro') && (<Button icon="pi pi-eraser" onClick={() => onEdit(event)} style={{ background: 'transparent', color: 'gray', border: 'none' }} />)}
      </div>
    );
  };


  useEffect(() => {
    const lazyClient = {
      first: 0,
      rows: 99999999,
      page: 1,
      cliente: 'null',
      documento: 'null',
      codigo: 'null',
      inativo: null,
      sortField: 'nome',
      sortOrder: SortOrder.DESC
    }
    const clientes: any[] = [];
    if (!state.user.cliente) {
      findClient(lazyClient).then(data => {
        data.clientes.forEach((c: { nome: string; id: string; }) => {
          clientes.push({ name: c.nome, code: c.id })
        })
      })
    }

    setClients(clientes);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (lazyState.documento) {
      lazyState.documento = lazyState.documento.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '');
    }
    loadLazyData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyState, date])

  return (
    <div>
      <div className="card">
        <Toolbar start={startContent} />
        <br></br>
        <div className="status-cards">
          {counts.map((item: any, index: number) => {
            const cfg = getCardConfig(item.status);
            const isTotal = item.status === 'undefined';
            const selected = !!status && status === item.status;
            const dimmed = !!status && status !== item.status;
            return (
              <Card
                key={index}
                style={{ cursor: 'pointer', borderTop: `4px solid ${cfg.color}` }}
                className={'status-card' + (dimmed ? ' disabled' : '') + (selected ? ' status-card--selected' : '')}
                onClick={() => changeStatus(!isTotal ? item.status : null)}
              >
                <div className="status-card__head">
                  <span className="status-card__icon" style={{ backgroundColor: cfg.color }}>
                    <i className={cfg.icon} />
                  </span>
                  {selected && (
                    <Button
                      icon="pi pi-times"
                      text
                      className="button_remove_backgroung status-card__clear"
                      onClick={(e) => { e.stopPropagation(); changeStatus(null) }}
                      style={{ color: 'rgb(24, 52, 98)' }}
                      aria-label="Limpar filtro"
                    />
                  )}
                </div>
                <span className="status-card__label">{item.statusLabel}</span>
                <span className="status-card__total">{item.total}</span>
                <span className="status-card__value">R$ {item.valorTotal}</span>
              </Card>
            );
          })}
        </div>
        <br></br>
        <DataTable value={registros} first={lazyState.first} dataKey="id" paginator={true} lazy={true}
          emptyMessage="Sem registros" header={header}
          onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
          rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
          tableStyle={{ minWidth: '75rem' }}>
          <Column field="cliente" header={t('cliente')} />
          <Column field="documento" sortable header={t('documento')} />
          <Column field="nome" sortable header={t('nome')} />
          <Column field="contrato" sortable header={t('contrato')} />
          <Column field="valor" sortable header={t('valor')} />
          <Column field="ocorrencia" sortable header={t('dtOcorrencia')} />
          <Column field="dataInclusao" sortable header={t('dtInclusao')} />
          <Column body={statusTemplate} sortable sortField='status' header={t('status')} />
          <Column field="email" header={t('email')} />
          <Column field="sms" header={t('sms')} />
          <Column field="tipoComunicado" sortable sortField='tipoComunicacao' header={t('tipoComunicado')} />
          <Column field="dataComunicado" sortable sortField='dataComunicacao' header={t('dataComunicado')} />
          <Column body={actionTemplate} />
          <Column style={{ width: '11%' }} body={downloadTemplate} />

        </DataTable>
      </div>
      <Dialog header={t('erros')} visible={descricaoErro} style={{ width: '80vw' }} onHide={() => resetForm()} footer={footerContent}>
        <p>{descricaoErro}</p>
      </Dialog>
    </div>
  )
}